// extracted by mini-css-extract-plugin
export var sliderRange = "_rn-2";
export var sliderRoot = "_rn-0";
export var sliderThumb = "_rn-3";
export var sliderTrack = "_rn-1";